<template>
  <div class="my-3 grid grid-cols-2 items-center gap-3">
    <RfInputWithMeasures v-model="width" :measures="measures" :label="`${prefix} Width`" />
    <RfInputWithMeasures v-model="height" :measures="measures" :label="`${prefix} Height`" />
    <RfInputWithMeasures v-model="positionX" :measures="measures" :label="`${prefix} Position X`" />
    <RfInputWithMeasures v-model="positionY" :measures="measures" :label="`${prefix} Position Y`" />
  </div>
</template>

<script setup>
import RfInputWithMeasures from "@/components/legacy/RfInputWithMeasuresLegacy.vue";
import { NONE_MEASURE, ROKU_MEASURES, useCSSProperty } from "@/utils/composables/useCSSProperty";
import { computed } from "vue";

const props = defineProps({
  prefix: { type: String, default: "Button 1" },
  isWeb: { type: Boolean, default: false },
});

const widthModel = defineModel("width", { type: String, default: "0px" });
const heightModel = defineModel("height", { type: String, default: "0px" });
const positionXModel = defineModel("positionX", { type: String, default: "0px" });
const positionYModel = defineModel("positionY", { type: String, default: "0px" });

const { variable: width } = useCSSProperty(() => widthModel, "value", { canBeEmpty: true });
const { variable: height } = useCSSProperty(() => heightModel, "value", { canBeEmpty: true });
const { variable: positionX } = useCSSProperty(() => positionXModel, "value");
const { variable: positionY } = useCSSProperty(() => positionYModel, "value");

const measures = computed(() => (props.isWeb ? [...ROKU_MEASURES, NONE_MEASURE] : ROKU_MEASURES));
</script>
